module.exports = __webpack_public_path__ + "img/examples-en-2.12071f4f.jpg";